import {Injectable} from '@angular/core';
import * as globals from '../settings';
import {TimeService} from './time.service';
import {Observable, Subject, Subscription} from 'rxjs';
import {SubscriptionsService} from './subscriptions.service';
import {LoginService} from '../shared/navigation/login.service';
import {LanguageService} from './language.service';
import {LotteriesService} from '../lotteries.service';
import {CartService} from './cart.service';
import {Router} from '@angular/router';
import {BowserService} from 'ngx-bowser';
import {CurrencyService} from './currency.service';
import {GetPaymentMethodsService} from '../shared/paymentMethod/get-payment-methods.service';
import {CookieService} from 'ngx-cookie-service';
import {Renderer2, RendererFactory2} from '@angular/core';


@Injectable()
export class UserService {
    timeZone: string;
    virtualLogin: string;
    showLogin: boolean;
    userData: any;
    userBalance: any;
    userDataNameWithGender: any;
    cart: any;
    error74: boolean;
    errorDefault: boolean;
    virtualLoginSubscription: Subscription;
    private renderer: Renderer2;
    step3: boolean; // prevent trigger game when 3rd step open.
    constructor(private timeService: TimeService,
                private router: Router,
                private bowser: BowserService,
                private subscriptionsService: SubscriptionsService,
                private loginService: LoginService,
                private languageService: LanguageService,
                private cookieService: CookieService,
                public lotteryService: LotteriesService,
                private cartService: CartService,
                rendererFactory: RendererFactory2) {
        this.step3 = false;
        this.virtualLoginSubscription = this.subscriptionsService.getVirtualLogin().subscribe(
            virtualLogin => {
                this.virtualLogin = virtualLogin;
            }
        );

        this.subscriptionsService.getUserAfterRegistration().subscribe(
            data => {
                this.doAfterLogin(data, data.sessionId);
            }
        );
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    public getUser() {
        const user = localStorage.getItem('playerDetails');
        if (user) {
            this.userData = JSON.parse(user);
            this.subscriptionsService.emitIsLoggedIn(true);
        }
    }

    public sendSomeCookies(cookieString) {
        return new Promise((resolve) => {
            const sendData = {};
            sendData['sessionId'] = this.userData.sessionId;
            sendData['cookieValue'] = cookieString;
            this.loginService
                .postData
                (`${globals.appDomain}/user/details/${this.userData.memberId}/sendCookieIncentive.json`,
                    this.loginService.getFormUrlEncoded(sendData)).subscribe(result => {
                this.cookieService.delete('incentiveCode');
                resolve(result);
            });
        });
    }

    public getUserDetails(sessionId, memberId, addToCart) {
        return new Promise((resolve) => {
            this.timeZone = this.timeService.getTimezone();

            if (localStorage.getItem('virtualLogin')) {
                this.virtualLogin = '&virtualLogin=' + localStorage.getItem('virtualLogin');
                this.subscriptionsService.emitVirtualLogin(this.virtualLogin);
            }

            const sendData = {};
            sendData['sessionId'] = sessionId;
            if (this.virtualLogin) {
                sendData['virtualLogin'] = this.virtualLogin.split('=')[1];
            }
            sendData['timeZone'] = this.timeZone;
            const cookieIncentiveCodeExists: boolean = this.cookieService.check('incentiveCode');
            if (cookieIncentiveCodeExists) {
                sendData['cookieValue'] = this.cookieService.get('incentiveCode');
                this.cookieService.delete('incentiveCode');
            }
            this.loginService
                .postData
                (globals.appDomain + '/user/details/' + memberId +
                    '/userDetails_nav_7.json', this.loginService.getFormUrlEncoded(sendData))
                .subscribe(
                    data => {
                        this.subscriptionsService.updateBalance(+data.message.TotalBalance);
                        this.showLogin = false;
                        const loggedInUser = data.message;
                        loggedInUser.sessionId = sessionId;
                        loggedInUser.memberId = memberId;
                        localStorage.setItem('playerDetails', JSON.stringify(loggedInUser));
                        resolve('user');
                        this.getUser();
                        if (addToCart) {
                            this.doAfterLogin(loggedInUser, sessionId);
                        }

                        this.subscriptionsService.emitChangeCurrency(data.message.Currency);
                        this.checkStatus(data.message.Status);
                        this.subscriptionsService.triggerNameMagic(true);
                        setTimeout(() => {
                            this.subscriptionsService.triggerNameMagic(true);
                        }, 1000);
                    }
                );
        });
    }

    checkStatus(data) {
        const language = localStorage.getItem('pageLanguage');
        return new Promise((resolve) => {
            if (data === '4') {
                this.renderer.addClass(document.body, 'suspInfoOpened');
                resolve('redirect');
                localStorage.setItem('dashboardStatus', 'verification');
                this.router.navigate(['/' + language, 'dashboard']);
            } else {
                resolve('noRedirect');
            }
        });
    }

    doAfterLogin(loggedInUser, sessionId) {
        this.userData = loggedInUser;
        this.userBalance = this.userData.TotalBalance;
        this.userDataNameWithGender = {
            FirstName: this.userData.FirstName,
            LastName: this.userData.LastName,
            Gender: this.userData.Gender,
        };
        this.subscriptionsService.updateUserDataNameWithGender(this.userDataNameWithGender);
        this.subscriptionsService.emitShowLogin(this.showLogin);
        this.subscriptionsService.emitToggleContent(true);
        this.subscriptionsService.emitUserData(this.userData);
        this.subscriptionsService.updateBalance(this.userBalance);
        this.subscriptionsService.emitIsLoggedIn(true);
        this.languageService.setLanguage(loggedInUser.LanguageID);
        this.cartService.addToCartAfterLogin(sessionId, this.userData, this.cart, this.error74, this.errorDefault);
    }

    public logOut() {
        let loggedIn = true;
        localStorage.removeItem('virtualLogin');
        const userFromStorage = localStorage.getItem('playerDetails');
        if (userFromStorage) {
            this.userData = JSON.parse(userFromStorage);
        }
        const sessionId = 'sessionId=' + this.userData.sessionId;
        this.lotteryService.postData(globals.appDomain + '/user/logout/userLogout_nav.json', sessionId)
            .subscribe(
                data => {
                    localStorage.removeItem('playerDetails');
                    localStorage.removeItem('freshAddedPaymentMethodId');
                    localStorage.removeItem('cart');
                    localStorage.removeItem('tempCart');
                    localStorage.setItem('knownUser', 'true');
                    this.subscriptionsService.updateLogout(true);
                    this.subscriptionsService.updateCart(0);
                    this.subscriptionsService.updateBalance(0);
                    this.subscriptionsService.emitIsLoggedIn(false);
                    loggedIn = false;
                    if (loggedIn === false) {
                        delete this.userData;
                        this.userData = undefined;
                        this.lotteryService.destroy.next();
                        this.lotteryService.destroy.complete();
                        this.subscriptionsService.emitGetPaymentMethods(false);
                        if (this.router.url.toString().includes('/dashboard') || this.router.url.toString().includes('/cart')) {
                            this.router.navigate(['/']);
                        }
                    }
                }
            );

        return loggedIn;
    }
}
